import { render, staticRenderFns } from "./TPagination.vue?vue&type=template&id=0ae00507&scoped=true&"
import script from "./TPagination.vue?vue&type=script&lang=js&"
export * from "./TPagination.vue?vue&type=script&lang=js&"
import style0 from "./TPagination.vue?vue&type=style&index=0&id=0ae00507&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae00507",
  null
  
)

export default component.exports